import { render, staticRenderFns } from "./copyShell.vue?vue&type=template&id=37591123"
import script from "./copyShell.vue?vue&type=script&lang=js"
export * from "./copyShell.vue?vue&type=script&lang=js"
import style0 from "./copyShell.vue?vue&type=style&index=0&id=37591123&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports